import { createFileRoute } from '@tanstack/react-router';
import { AccessPermissions } from '@/features/auth/AccessPermissions';

export const Route = createFileRoute('/_auth/access-permissions')({
  component: AccessPermissions,
  validateSearch: (s: Record<string, unknown>) => ({
    otp: typeof s.otp === 'string' ? s.otp : undefined,
    // Link email Template C: &result=true|false (accetta/rifiuta). Assente = imposta password.
    result: s.result === true || s.result === 'true' ? true
      : s.result === false || s.result === 'false' ? false
        : undefined,
  }),
});
